import { useRef } from 'react'
import Pult from '../Pult/Pult'
import Card from '../Card/Card'
import Slider from 'react-slick'
import './MySlider.css'

const MySlider = ({ content }) => {
  const slider = useRef(null)
  let settings = {
    arrows: false,
    dots: false,
    infinite: true,
    initialSlide: 1,
    mobileFirst: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true,
          initialSlide: 0,
        },
      },
    ],
  }
  const goBack = () => slider.current.slickPrev()
  const goNext = () => slider.current.slickNext()

  return (
    <div className='sliderWrap'>
      {/* <div className='flex' style={{ gap: 30 }}> */}
      <Slider ref={slider} {...settings}>
        {content.map((item) => (
          <Card key={item.h3} h3={item.h3} tech={item.tech} img={item.img} p={item.p} />
        ))}
      </Slider>
      <Pult goBack={goBack} goNext={goNext} />
    </div>
  )
}

export default MySlider
